import { makeStyles } from "@material-ui/core";

export const useClientAccountRowStyles = makeStyles((theme) => ({
    paper: {
        padding: ".5em .5em .7em 1.2em",
        marginBottom: '5px'
    },
    icons: {
        paddingRight: "1em"
    },
    errorText: {
        color: theme.palette.error.main,
        fontSize: '0.8em',
        marginTop: '4px'
    }
}));
